import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { CourierServiceScheduleSaveDto } from './config'

export const getCouriers = (
  filters?: Filter[],
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.CourierCollectionPlannerApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters && filters.length > 0) {
    filters.forEach((filter) => {
      url.searchParams.set(filter.key, filter.value)
    })
  }

  return axios.get(url.toString())
}

export const getCourierServiceSchedule = (courierServiceId: number) => {
  const url = new URL(
    `${ApiConfig.CourierCollectionPlannerApi}/${courierServiceId}/schedule`
  )
  return axios.get(url.toString())
}

export const putCourierServiceSchedule = (dto: CourierServiceScheduleSaveDto) => {
  const url = new URL(`${ApiConfig.CourierCollectionPlannerApi}/schedule`)
  return axios.put(url.toString(), dto)
}

export const deleteCourierServiceSchedule = (courierServiceId: number) => {
  const url = new URL(
    `${ApiConfig.CourierCollectionPlannerApi}/${courierServiceId}/schedule`
  )
  return axios.delete(url.toString())
}

